import { Component, Prop } from 'vue-property-decorator';
import TombolaBaseComponent from '@/components/base/base.component';
import { SERVICE_IDENTIFIERS } from '@/app-modules/_ioc/service-identifiers';
import { IGameWinnersViewModel } from '@/app-modules/config/models/game-winners-model';
import { IGameWinnersService } from '@/app-modules/game-winners/game-winners-service-interface';
import { IGameWinnerDetailedViewModel, IIndividualGameWinnerViewModel } from '@/app-modules/config/models/game-winners-detailed-model';
import { ConfigurationKey } from '@/app-modules/config';
import _ from 'lodash';

@Component({
  name: 'ReelBingoWinnersComponent'
})
export default class ReelBingoWinnersComponent extends TombolaBaseComponent {
  @Prop() public gameName: string;
  private gameWinnersResults: IGameWinnersViewModel[];
  private previousGameWinners: IGameWinnerDetailedViewModel[] = [];
  private previousJackpotGameWinners: IGameWinnerDetailedViewModel[] = [];
  private winnersUpdateIntervalHandle: number = 0;
  private isLoading: boolean = false;

  private get gamesWinnersService(): IGameWinnersService {
    return this.$container.get(SERVICE_IDENTIFIERS.IGameWinnersService) as IGameWinnersService;
  }

  private async mounted() {
    this.getAndUpdateWinners();

    const winnersUpdateIntervalMilliseconds = Number(this.configService.getConfigurationItem(ConfigurationKey.GAME_HISTORY_REFRESH_INTERVAL_MS));
    this.winnersUpdateIntervalHandle = window.setInterval(async () => await this.getAndUpdateWinners(), winnersUpdateIntervalMilliseconds);
  }

  private beforeDestroy() {
    if (this.winnersUpdateIntervalHandle) {
      window.clearInterval(this.winnersUpdateIntervalHandle);
      this.winnersUpdateIntervalHandle = 0;
    }
  }

  private async getAndUpdateWinners() {
    try {
      this.isLoading = true;
      this.gameWinnersResults = await this.gamesWinnersService.getGameWinners(this.gameName);
      this.previousGameWinners = this.getPrevious10GameWinners(this.gameWinnersResults);
      this.previousJackpotGameWinners = this.getPrevious10JackpotGameWinners(this.gameWinnersResults);
    }
    finally {
      this.isLoading = false;
    }
  }

  private getPrevious10GameWinners(gameWinnersResults: IGameWinnersViewModel[]): IGameWinnerDetailedViewModel[] {
    let winnersList = new Array<IGameWinnerDetailedViewModel>();
    gameWinnersResults.forEach((item) => winnersList = winnersList.concat(item.gameWinners));

    const tempList = winnersList.sort((a: IGameWinnerDetailedViewModel, b: IGameWinnerDetailedViewModel) => {
      return this.SortDateDescending(a.stamp, b.stamp);
    });

    return _.uniqWith(tempList, _.isEqual).slice(0, 10);
  }

  private getPrevious10JackpotGameWinners(gameWinnersResults: IGameWinnersViewModel[]): IGameWinnerDetailedViewModel[] {
    let winnersList = new Array<IGameWinnerDetailedViewModel>();
    gameWinnersResults.forEach((item) => winnersList = winnersList.concat(item.jackpotWinners));

    const tempList = winnersList.sort((a: IGameWinnerDetailedViewModel, b: IGameWinnerDetailedViewModel) => {
      return this.SortDateDescending(a.stamp, b.stamp);
    });

    return _.uniqWith(tempList, _.isEqual).slice(0, 10);
  }

  private getWinnerMessageForUser(gameWinner: IIndividualGameWinnerViewModel): string {
    const messageTemplate: string = this.$lang.game.winners.winnerTemplate;
    return messageTemplate.format({
      username: gameWinner.username,
      prize: gameWinner.prize.toFixed(2)
    });
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/game-winners/_components/reel-bingo/reelbingo.winners-view.component.ts